/**
 * Pages that bring their own full-page chrome — their own nav, their own
 * footer, their own way back into the app — and so must not be wrapped in the
 * library shell even for a signed-in visitor.
 *
 * The landing page is the reason this exists: it has always rendered its own
 * header (with a Dashboard button for anyone signed in) and its own footer, so
 * a signed-in visitor got two navigations at once, the library sidebar pinned
 * beside a page that already offers its own way in. The legal pages and the
 * install guide share that layout and had the same problem.
 *
 * A route, not a session, decides this: the visitor is the same person either
 * way, and what changes is the page.
 */
const EXACT = new Set(["/", "/terms", "/privacy"]);

/** Matched on the segment boundary, so /installer would not qualify. */
const PREFIXES = ["/install"];

export function hasOwnChrome(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  // A trailing slash is the same page. "/" itself is left alone.
  const path = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  if (EXACT.has(path)) return true;
  return PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
